export const formatTranslation = (template, values = {}) =>
	String(template).replace(/\{(\w+)\}/g, (_, key) =>
		values[key] !== undefined ? String(values[key]) : `{${key}}`,
	);
